import { __awaiter, __decorate, __rest } from "tslib";
import { define } from 'type-r';
import { RestfulEndpoint } from './restful.js';
export function fetchModelIO(method, url, options) {
    return new ModelFetchEndpoint(method, url, options);
}
function notSupported(method) {
    throw new ReferenceError(`Method ${method} is not supported. modelFetchIO supports only model.fetch().`);
}
let ModelFetchEndpoint = class ModelFetchEndpoint extends RestfulEndpoint {
    constructor(method, constructUrl, _a = {}) {
        var { mockData } = _a, options = __rest(_a, ["mockData"]);
        super('', mockData ? Object.assign({ mockData: [mockData] }, options) : options);
        this.method = method;
        this.constructUrl = constructUrl;
    }
    list() {
        return __awaiter(this, void 0, void 0, function* () { notSupported('collection.fetch()'); });
    }
    destroy() {
        return __awaiter(this, void 0, void 0, function* () { notSupported('model.destroy()'); });
    }
    create() {
        return __awaiter(this, void 0, void 0, function* () { notSupported('model.save()'); });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () { notSupported('model.save()'); });
    }
    read(id, options, model) {
        return __awaiter(this, void 0, void 0, function* () {
            this.url = this.constructUrl(options.params, model);
            return this.request(this.method, this.getRootUrl(model), options);
        });
    }
};
ModelFetchEndpoint = __decorate([
    define
], ModelFetchEndpoint);
//# sourceMappingURL=fetchModel.js.map